// 「經期比預期晚了」的溫馨提示（W58.1）。
//
// **它出現的時機是刻意的。** 推算的經期開始日已經過去 3 天以上，而且
// 這一段沒有任何實際記錄 —— 這是「忘了記錄」唯一的訊號。
//
// **為什麼它繞過離散度閘門。** 見後端 `service/cycle.py` 的
// `median_interval()`：使用者遲到 12 天才補記，正是最需要被提醒的情況，
// 而那也正是間隔離散度會爆掉、整個推算消失的情況。所以「遲了幾天」走
// 中位數那條路 —— **它是推算消失時唯一還在講話的訊號**。
//
// **「一鍵補記」是真的 一鍵。** 它開的是一個**已經是週期類型**的表單
// （`?category=cycle`），結束日已經依平均經期長度自動展開 —— 使用者要的
// 只是按下「建立事件」。

import { InfoBanner } from "@/components/primitives/InfoBanner";
import { CycleFlower } from "@/components/calendar/CycleFlower";

/** 推算的經期開始日過去幾天算「遲了」。與後端的 `LATE_THRESHOLD_DAYS` 同值。 */
export const LATE_THRESHOLD_DAYS = 3;

export interface CycleLateNoticeProps {
  /** 遲了幾天。`0` 或 `null` = 沒有延遲。 */
  daysLate: number | null;
  /** 「一鍵補記」—— 開一個已經是週期類型的表單。 */
  onRecord: () => void;
}

export function CycleLateNotice({ daysLate, onRecord }: CycleLateNoticeProps) {
  if (daysLate == null || daysLate <= LATE_THRESHOLD_DAYS) return null;

  return (
    <div data-testid="calendar-cycle-late-notice">
      <InfoBanner
        tone="partner"
        // W58.6 —— **用自繪的花，不用 lucide 的 `Flower2`。**
        // 這個橫幅是「經期」的第二個圖示來源，而 `Flower2` 的花頭是四段圓弧 +
        // 一個花心圓 —— 那正是 ADR-0209 推翻它的理由（「麻將一筒」）。留下它
        // 等於在同一個畫面上放兩種花。
        icon={<CycleFlower size={16} />}
      >
        <span className="text-ink-1">
          經期比預期晚了 <strong className="font-semibold">{daysLate}</strong> 天還沒記錄。
        </span>
        <button
          type="button"
          onClick={onRecord}
          data-testid="calendar-cycle-late-record"
          className="mt-s-1 min-h-11 whitespace-nowrap rounded-pill bg-partner-strong px-s-3 text-meta font-semibold text-paper hover:opacity-90"
        >
          一鍵補記
        </button>
      </InfoBanner>
    </div>
  );
}
